import { AxiosError } from 'axios';
import { AppForm, AppFormProps, ParentMailThreadRecipientsPicker } from 'components/organisms';
import { ParentMailThreadFormFields } from 'types';
import {
    AttachmentsUploadElement,
    FormNavButtons,
    SimpleInputElement,
    SimpleTextAreaElement,
} from 'components/molecules';
import { messagesTexts } from 'consts/text';
import { StyledSendIcon } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import ParentHTTPService from 'services/HTTPService/parent/ParentHTTPService';
import { mailThreadAddEditErrorParser } from 'utils/errorHandlers/mailThread/mailThreadAddEditErrorParser';
import { max2000LengthRule, max300LengthRule } from 'consts/rules/textRules';
import { MESSAGE_ATTACHMENT_FORMATS } from 'consts/file/fileFormats';

type ParentMailThreadAddFormProps = Omit<
    AppFormProps<ParentMailThreadFormFields>,
    'width' | 'title' | 'name' | 'onFinish' | 'error' | 'withGoBack' | 'mode'
> & {
    axiosError?: AxiosError | null;
    isLoading?: boolean;
    mode?: 'add' | 'reply';
    onFinish: (parentMailThreadFormFields: ParentMailThreadFormFields) => void;
};

const FORM_MAX_WIDTH = 600;

export const ParentMailThreadAddForm = ({
    axiosError,
    mode = 'add',
    ...restProps
}: ParentMailThreadAddFormProps) => {
    const parentMailThreadAddError = axiosError
        ? mailThreadAddEditErrorParser(axiosError)
        : undefined;

    return (
        <AppForm<ParentMailThreadFormFields>
            title={messagesTexts.newMessage}
            name="mailThreadAdd"
            error={parentMailThreadAddError}
            withGoBack
            maxWidth={FORM_MAX_WIDTH}
            {...restProps}
        >
            <ParentMailThreadRecipientsPicker disabled={mode === 'reply'} />
            <SimpleInputElement
                name={formFields.topic}
                label={messagesTexts.messageTopic}
                rules={[max300LengthRule]}
                placeholder="Podaj temat wiadomości"
            />
            <SimpleTextAreaElement
                name={formFields.content}
                rules={[max2000LengthRule]}
                label={messagesTexts.messageContent}
                rows={8}
                resizable={false}
                placeholder="Wpisz treść wiadomości..."
            />
            <AttachmentsUploadElement
                uploadDirectory="MESSAGE"
                accept={MESSAGE_ATTACHMENT_FORMATS}
                uploadAttachmentFunction={ParentHTTPService.files.addFile}
                placeholder="Wybierz załączniki"
            />
            <FormNavButtons buttonText={messagesTexts.sendMessage} leftIcon={<StyledSendIcon />} />
        </AppForm>
    );
};
